import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AttachmentEventService {
    private readonly _applicationAttachmentsChanged$ = new Subject<void>();

    applicationAttachmentsChanged$: Observable<void> =
        this._applicationAttachmentsChanged$.asObservable();

    /**
     * Notifies subscribers on the application attachments changed observable that attachments have changed.
     */
    notifyApplicationAttachmentsChanged(): void {
        this._applicationAttachmentsChanged$.next();
    }
}
